import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

const props = withCompInfo<any, any>()(
  ['compData', 'compStylableClass'],
  ({ compData, compStylableClass }) => {
    return {
      ...{
        autoplay: true,
        loop: true,
        speed: 1,
        animationUrl:
          'https://assets1.lottiefiles.com/packages/lf20_tr1pjkop.json',
      },
      ...compData,
      className: compStylableClass,
    };
  },
);

export default createComponentMapperModel({
  props,
});
